import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "256",
  height: "256",
  fill: "currentColor",
  viewBox: "0 0 200 200"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M130 36q-60-6-70 54-4 40 20 60 12 12 24 12 14 0 16-14t-6-20q-14-8-12-20t14-12q18 0 28-12 12-14 8-30t-22-18" }, null, -1),
    _createElementVNode("path", {
      fill: "none",
      stroke: "var(--mc-avatar)",
      "stroke-linecap": "round",
      "stroke-width": "6",
      d: "M110 84q-14 2-18 16-4 16 10 22"
    }, null, -1)
  ]))]))
}
export default { render: render }